import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, isRef as _isRef, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/image/fff.png';
import _imports_1 from '../../assets/image/close.png';
const _withScopeId = n => (_pushScopeId("data-v-41e92fe6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "prompt"
};
const _hoisted_2 = {
  class: "prompt_title"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  class: "tk-botton"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ccc"
}, null, -1));
const _hoisted_6 = {
  class: "tk-mian"
};
const _hoisted_7 = {
  class: "tk-swiper"
};
const _hoisted_8 = {
  class: "tk-notice"
};
const _hoisted_9 = {
  class: "tk-home-tabs"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "icon"
};
const _hoisted_12 = ["src"];
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  class: "name"
};
const _hoisted_15 = ["onClick"];
const _hoisted_16 = {
  class: "icon"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = ["src"];
const _hoisted_19 = {
  class: "name"
};
const _hoisted_20 = {
  class: "tk-lottery"
};
const _hoisted_21 = {
  class: "tk-home"
};
const _hoisted_22 = ["onClick"];
const _hoisted_23 = {
  class: "icon"
};
const _hoisted_24 = ["src"];
const _hoisted_25 = {
  class: "name"
};
const _hoisted_26 = {
  key: 0,
  class: "title"
};
const _hoisted_27 = {
  key: 1,
  class: "title"
};
const _hoisted_28 = {
  class: "desc"
};
const _hoisted_29 = {
  key: 1,
  class: "tk-materials-box"
};
const _hoisted_30 = {
  class: "block"
};
const _hoisted_31 = {
  class: "ti"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1));
const _hoisted_33 = {
  class: "indexgp"
};
const _hoisted_34 = ["src"];
const _hoisted_35 = {
  colspan: "2",
  style: {
    "border": "none"
  }
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "left"
}, "挂牌", -1));
const _hoisted_37 = {
  class: "right"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "left"
}, "火烧", -1));
const _hoisted_39 = {
  class: "right"
};
const _hoisted_40 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "left"
}, "横批", -1));
const _hoisted_41 = {
  class: "right"
};
const _hoisted_42 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "left"
}, "门数", -1));
const _hoisted_43 = {
  class: "right"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "left"
}, "六肖", -1));
const _hoisted_45 = {
  class: "right"
};
const _hoisted_46 = {
  class: "ti"
};
const _hoisted_47 = ["onClick"];
const _hoisted_48 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更多", -1));
const _hoisted_49 = {
  key: 0,
  class: "zllist"
};
const _hoisted_50 = ["onClick"];
const _hoisted_51 = {
  key: 0,
  class: "appdow"
};
const _hoisted_52 = {
  class: "item a"
};
const _hoisted_53 = ["href"];
const _hoisted_54 = {
  class: "item b"
};
const _hoisted_55 = ["href"];
const _hoisted_56 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "更爽...", -1));
const _hoisted_57 = {
  class: "tk-major-bottons"
};
const _hoisted_58 = {
  class: "tk-main-QEcode"
};
const _hoisted_59 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_60 = [_hoisted_59];
const _hoisted_61 = {
  class: "tk-exit-name"
};
const _hoisted_62 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tk-exit-title"
}, "选择聊天室", -1));
const _hoisted_63 = {
  class: "tk-exit-from"
};
const _hoisted_64 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "新版六合聊天室", -1));
const _hoisted_65 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "more"
}, null, -1));
const _hoisted_66 = [_hoisted_64, _hoisted_65];
const _hoisted_67 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "旧版六合聊天室", -1));
const _hoisted_68 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "more"
}, null, -1));
const _hoisted_69 = [_hoisted_67, _hoisted_68];
const _hoisted_70 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bbb"
}, null, -1));
import { useKeepPage } from "@/router/useKeepPage";
import loadingTips from "@/components/mode/loading";
import wecharList from "@/components/me/wecharList.vue";
import kt_header from "@/components/page/header.vue";
import lottery from "@/components/page/lottery.vue";
import notiveVue from "@/components/page/notive.vue";
import { Waterfall } from "@/utils/Waterfall";
import loadings from "@/assets/image/error.png";
import error from "@/assets/image/error.png";
import { roomList } from "@/utils/https/wechar";
import Dialog from "@/components/mode/message.js";
import axios from "axios";
import { getCurrentInstance } from "vue";
import { listArticle } from "@/utils/https/materials";
import { pictureCate, years, swiperImg, yearAll, getMessage, config, getMaterial, lottery_years_color } from "@/utils/https/page";
// import {nextLottery} from '@/utils/https/https';
import { useStore } from "vuex";
import { nextTick, onBeforeMount, onBeforeUnmount, reactive, ref } from "vue";
import { number_attr } from "@/utils/https/statistics";

import { useRoute, useRouter } from 'vue-router';
import { toRefs, onMounted } from 'vue';
export default {
  __name: 'index',
  setup(__props) {
    const handleRefreshsx = () => {
      window.location.href = "https://t.me/tk49kj";
    };
    let listRoom = [];
    let showss = ref(false);
    useKeepPage(["indexs"]);
    let majorTab = item => {
      //是否显示聊天室
      if (item.name == "聊天室") {
        if (localStorage.getItem("room_info") != null) {
          list = JSON.parse(localStorage.getItem("room_info"));
          if (list.length == 1) {
            showss.value = true;
            listRoom.push({
              title: list[0].name,
              id: list[0].id
            });
          } else if (list.length == 0) {
            Dialog("暂无聊天列表");
          } else {
            gameShow.value = true;
          }
        } else {
          roomLists();
        }
      }
    };
    let selecRoom = item => {
      //选择聊天室
      router.push({
        path: "/wechat",
        query: {
          title: item.name,
          id: item.id
        }
      });
    };
    let selecRooms = id => {
      if (id == 1) {
        router.push({
          path: "/wechat",
          query: {
            title: listRoom[0].title,
            id: listRoom[0].id
          }
        });
      } else {
        router.push({
          path: "/wechat/liuhe"
        });
      }
    };
    const route = useRoute();
    // import { Waterfall } from 'vue-waterfall-plugin-next'
    const router = useRouter();
    let tkHome = reactive([{
      icon: require("../../assets/image/major/2057.png"),
      name: "开奖直播",
      color: "#E3F4FF",
      desc: "现场直播开奖",
      path: "/lottery"
    }, {
      icon: require("../../assets/image/major/2063.png"),
      name: "图库",
      color: "#ECFFF5",
      desc: "六合图库免费看",
      path: "/image"
    }, {
      icon: require("../../assets/image/major/2058.png"),
      name: "资料大全",
      color: "#ECFFF5",
      desc: "超准资料免费转",
      path: "/materials"
    }, {
      icon: require("../../assets/image/major/2062.png"),
      name: "幽默猜测",
      color: "#FCF0FF",
      desc: "幽默风趣猜测",
      path: "/guess"
    }, {
      icon: require("../../assets/image/major/3029.png"),
      name: "高手彩图",
      color: "#E3E9FF",
      desc: "高手彩图大全",
      path: "/discover"
    }, {
      icon: require("../../assets/image/major/3026.png"),
      name: "六合公式",
      color: "#F8F6E1",
      desc: "六合公式大全",
      path: "/master/liuhe"
    }, {
      icon: require("../../assets/image/major/2059.png"),
      name: "资讯统计",
      color: "#E2FFFF",
      desc: "详细大数据统计",
      path: "/statistics"
    }, {
      icon: require("../../assets/image/major/2064.png"),
      name: "高手论坛",
      color: "#F4FFE7",
      desc: "高手间分析反馈",
      path: "/master"
    }, {
      icon: require("../../assets/image/major/2060.png"),
      name: "开奖记录",
      color: "#E3F4FF",
      desc: "历史开奖记录",
      path: "/lottery/history"
    }, {
      icon: require("../../assets/image/major/2065.png"),
      name: "工具宝箱",
      color: "#FFF4DF",
      desc: "六合工具大全",
      path: "/tool"
    }]);
    let tkHomeTabs = reactive([{
      icon: require("../../assets/image/major/provice/2031.png"),
      name: "新澳彩",
      id: "2",
      selectIcon: require("../../assets/image/major/provice/2015.png")
    }, {
      icon: require("../../assets/image/major/provice/2017.png"),
      name: "港彩",
      id: "1",
      selectIcon: require("../../assets/image/major/provice/2028.png")
    }, {
      icon: require("../../assets/image/major/provice/2031.png"),
      name: "快乐八",
      id: "6",
      selectIcon: require("../../assets/image/major/provice/2015.png")
    }, {
      icon: require("../../assets/image/major/provice/2031.png"),
      name: "天澳彩",
      id: "5",
      selectIcon: require("../../assets/image/major/provice/2015.png")
    }, {
      icon: require("../../assets/image/major/provice/2031.png"),
      name: "老澳",
      id: "7",
      selectIcon: require("../../assets/image/major/provice/2015.png")
    }
    // {icon:require('../../assets/image/major/provice/2018.png'),name:'台彩',id:'3',selectIcon:require('../../assets/image/major/provice/2029.png')},
    // {icon:require('../../assets/image/major/provice/2032.png'),name:'新彩',id:'4',selectIcon:require('../../assets/image/major/provice/2019.png')},
    ]);

    let tkHomeTabss = reactive([
    // {icon:require('../../assets/image/major/provice/2031.png'),name:'天澳彩',id:'5',selectIcon:require('../../assets/image/major/provice/2015.png')},
    {
      icon: require("../../assets/image/major/provice/2031.png"),
      name: "新澳彩",
      id: "2",
      selectIcon: require("../../assets/image/major/provice/2015.png")
    }, {
      icon: require("../../assets/image/major/provice/2017.png"),
      name: "港彩",
      id: "1",
      selectIcon: require("../../assets/image/major/provice/2028.png")
    }, {
      icon: require("../../assets/image/major/provice/2031.png"),
      name: "快乐八",
      id: "6",
      selectIcon: require("../../assets/image/major/provice/2015.png")
    }, {
      icon: require("../../assets/image/major/provice/2031.png"),
      name: "老澳",
      id: "7",
      selectIcon: require("../../assets/image/major/provice/2015.png")
    }
    // {icon:require('../../assets/image/major/provice/2018.png'),name:'台彩',id:'3',selectIcon:require('../../assets/image/major/provice/2029.png')},
    // {icon:require('../../assets/image/major/provice/2032.png'),name:'新彩',id:'4',selectIcon:require('../../assets/image/major/provice/2019.png')},
    ]);

    let data = reactive({
      //请求处理交互数据
      yearList: [],
      pictureData: [],
      swiperImgsrc: [],
      page: 1,
      year: "2024",
      color: "1",
      gameShow: false,
      noticeData: [],
      prompt_title: "",
      noticeCont: "",
      websiteName: JSON.parse(localStorage.getItem("config")) == null ? {} : JSON.parse(localStorage.getItem("config")),
      https: process.env.VUE_APP_BASE_API_S,
      refreshKey: "1",
      transitions: false
    });
    let {
      yearList,
      pictureData,
      swiperImgsrc,
      gameShow,
      noticeData,
      noticeCont,
      websiteName,
      https,
      refreshKey,
      transitions,
      prompt_title
    } = toRefs(data);
    let datas = reactive({
      show: false,
      acitveIndexLottery: 2,
      //彩票选择
      lotteryName: "快乐八",
      shows: false,
      types: "am",
      materData: []
    });
    let {
      show,
      acitveIndexLottery,
      shows,
      lotteryName,
      types,
      materData
    } = toRefs(datas);
    //滚动置顶

    const scrollYear = ref(null);
    const wrapper = ref(null);
    let scroolData = reactive({
      offsetTop: 0,
      scrollYear: false,
      yearTop: 0
    });
    let list = reactive([]);
    let roomLists = () => {
      roomList().then(res => {
        list.length = 0;
        let datas = res.data.data;
        if (datas.length == 1) {
          showss.value = true;
          listRoom.push({
            title: datas[0].name,
            id: datas[0].id
          });
        } else if (datas.length == 0) {
          Dialog("暂无聊天列表");
        } else {
          gameShow.value = true;
        }
        datas.forEach((item, index) => {
          switch (item.id) {
            case 1:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require("@/assets/image/major/provice/2028.png")
              });
              break;
            case 2:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require("@/assets/image/major/provice/2015.png")
              });
              break;
            case 3:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require("@/assets/image/major/provice/2029.png")
              });
              break;
            case 4:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require("@/assets/image/major/provice/2019.png")
              });
              break;
            case 5:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require("@/assets/image/major/provice/2015.png")
              });
              break;
            default:
              break;
          }
        });
        localStorage.setItem("room_info", JSON.stringify(list));
      });
    };
    let getQueryString = name => {
      let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      let r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return decodeURIComponent(r[2]);
      }
      return null;
    };
    let gpData = ref({
      // img:require('../../assets/imageerrey.png')
    });
    let ziliao = ref();
    let axiosTuku = lottery => {
      let url = `https://am.zlapi8.com/api/gp?type=${lottery}`;
      axios.get(url).then(res => {
        gpData.value = res.data.data;
      });
    };
    const {
      proxy
    } = getCurrentInstance();
    let guapaiInfo = type => {
      proxy.$sayHello();
      router.push({
        path: `/list/gp`,
        query: {
          type
        }
      });
    };
    onBeforeMount(() => {
      proxy.$sayHello();
      if (sessionStorage.getItem("times") < Date.now()) {
        sessionStorage.clear();
      }
      if (getQueryString("android") != null) {
        localStorage.setItem("downloadapp", false);
        tipsData.downloadapp = localStorage.getItem("downloadapp") == null ? "false" : localStorage.getItem("downloadapp"); //判断是否显示
      } else {
        tipsData.downloadapp = true;
      }
      if (localStorage.getItem("lotteryTypes") != null) {
        localStorage.setItem("lotteryType", localStorage.getItem("lotteryTypes"));
      }
      let swiperImgss = JSON.parse(localStorage.getItem("swiperImg"));
      if (swiperImgss && swiperImgss.expires > Date.now()) {
        data.swiperImgsrc.push(...swiperImgss.value);
      } else {
        swiperImgs();
      }
      if (localStorage.getItem("config") == null) {
        configs();
      }
      datas.acitveIndexLottery = localStorage.getItem("lotteryTypes") == null ? "2" : localStorage.getItem("lotteryTypes");
      yearsColos(datas.acitveIndexLottery);
      switch (datas.acitveIndexLottery) {
        case "5":
          datas.lotteryName = "天澳彩";
          getMaterials(datas.acitveIndexLottery);
          datas.types = "am48";
          axiosTuku("am48");
          break;
        case "6":
          datas.lotteryName = "快乐八";
          getMaterials(datas.acitveIndexLottery);
          datas.types = "am48";
          axiosTuku("am48");
          break;
        case "7":
          datas.lotteryName = "老澳";
          getMaterials(datas.acitveIndexLottery);
          datas.types = "oldam";
          axiosTuku("oldam");
          break;
        case "2":
          datas.lotteryName = "新澳彩";
          getMaterials(datas.acitveIndexLottery);
          datas.types = "am";
          axiosTuku("am");
          break;
        case "1":
          datas.lotteryName = "港彩";
          getMaterials(datas.acitveIndexLottery);
          datas.types = "xg";
          axiosTuku("xg");
          break;
        case "3":
          datas.lotteryName = "台彩";
          getMaterials(datas.acitveIndexLottery);
          datas.types = "tw";
          axiosTuku("tw");
          break;
        case "4":
          datas.lotteryName = "新彩";
          getMaterials(datas.acitveIndexLottery);
          datas.types = "xjp";
          axiosTuku("xjp");
          break;
      }
      const colseTiem = setInterval(() => {
        let yearList = JSON.parse(sessionStorage.getItem("yearList"));
        if (yearList) {
          yearList.forEach((item, index) => {
            if (item.lotteryType == datas.acitveIndexLottery) {
              localStorage.setItem("yearone", item.years[0]);
              localStorage.setItem("year", JSON.stringify(item.years));
            }
          });
          clearInterval(colseTiem);
        }
      }, 1000);
    });
    onMounted(() => {
      if (localStorage.getItem("number_attr") == null || localStorage.getItem("year") == null) {
        number_attrs();
        // yearAlls();
      }

      // 获取 DOM 元素

      //   scroolData.yearTop = scrollTabs.value?.offsetTop
      // // 监听滚动事件
      //   window.addEventListener('scroll', handleScroll)
      getMessages(1, 1);
    });
    const loading = ref(true);
    const finished = ref(true);
    const refreshing = ref(false);
    const onLoad = () => {
      picture(data.year, data.color, data.page, datas.acitveIndexLottery);
      data.page++;
    };
    const onRefresh = () => {
      localStorage.removeItem("lotteryNumber");
      proxy.$sayHello();
      datas.acitveIndexLottery = localStorage.getItem("lotteryTypes") == null ? 2 : localStorage.getItem("lotteryTypes");
      // 清空列表数据
      data.page = 1;
      //   data.yearList.length = 0;
      data.pictureData.length = 0;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      loading.value = false;
      //   onLoad();
      data.refreshKey += 1;
      switch (datas.acitveIndexLottery) {
        case "5":
          datas.lotteryName = "天澳彩";
          getMaterials(datas.acitveIndexLottery);
          datas.types = "am48";
          axiosTuku("am48");
          break;
        case "6":
          datas.lotteryName = "快乐八";
          getMaterials(datas.acitveIndexLottery);
          datas.types = "am48";
          axiosTuku("am48");
          break;
        case "7":
          datas.lotteryName = "老澳";
          getMaterials(datas.acitveIndexLottery);
          datas.types = "oldam";
          axiosTuku("oldam");
          break;
        case "2":
          datas.lotteryName = "新澳彩";
          getMaterials(datas.acitveIndexLottery);
          datas.types = "am";
          axiosTuku("am");
          break;
        case "1":
          datas.lotteryName = "港彩";
          getMaterials(datas.acitveIndexLottery);
          datas.types = "xg";
          axiosTuku("xg");
          break;
        case "3":
          datas.lotteryName = "台彩";
          getMaterials(datas.acitveIndexLottery);
          datas.types = "tw";
          axiosTuku("tw");
          break;
        case "4":
          datas.lotteryName = "新彩";
          getMaterials(datas.acitveIndexLottery);
          datas.types = "xjp";
          axiosTuku("xjp");
          break;
      }
    };

    //接口请求区域

    let number_attrs = () => {
      number_attr().then(res => {
        if (res.data.status == "40000") {
          return false;
        }
        let datas = res.data.data;
        localStorage.setItem("number_attr", JSON.stringify(datas));
      });
    };
    let getMaterials = async lottery => {
      //资料列表
      datas.materData.length = 0;
      let lotteryNumber = localStorage.getItem("materList") == null ? [] : JSON.parse(localStorage.getItem("materList"));
      let ress;
      if (lotteryNumber.length == 0) {
        ress = -1;
      } else {
        ress = lotteryNumber.findIndex(ev => {
          return ev.lottery == lottery;
        });
      }
      if (lotteryNumber.length != 0 && ress != -1) {
        lotteryNumber.forEach(item => {
          refreshing.value = false;
          if (item.lottery == lottery) {
            datas.materData.push(...item.data);
            refreshing.value = false;
          }
          if (item.tiems < Date.now()) {
            localStorage.removeItem("materList");
          }
        });
      } else {
        let res = await getMaterial({
          lotteryType: lottery
        });
        let data = res.data.data;
        lotteryNumber.push({
          lottery,
          data,
          tiems: Date.now() + 1000 * 60 * 30
        });
        localStorage.setItem("materList", JSON.stringify(lotteryNumber));
        datas.materData.push(...data);
        refreshing.value = false;
      }
    };
    let moreZiliao = item => {
      router.push({
        path: `materials/list`,
        query: {
          id: item.id,
          title: item.corpusTypeName,
          type: item.lotteryType
        }
      });
    };
    let handledesc = (id, typeId) => {
      router.push({
        path: `/materials/list/details`,
        query: {
          id: id,
          corpusTypeId: typeId
        }
      });
    };

    // let nextLotterys = ()=>{

    // }
    let handleSwipe = index => {
      data.prompt_title = data.noticeData[index].title;
    };
    let configs = () => {
      //获取公共配置
      config().then(res => {
        if (res == undefined) return false;
        let datas = res.data.data;
        data.websiteName = datas;
        document.title = datas.name;
        var head = document.getElementsByTagName("head")[0];
        // 获取当前 favicon 元素
        var favicon = document.querySelector("link[rel*='icon']") || document.createElement("link");
        favicon.type = "image/x-icon";
        favicon.rel = "shortcut icon";

        // 设置新的 favicon 地址
        favicon.href = datas.host + datas.logo;

        // 如果当前 head 标签中不存在 favicon 元素，则将新的 favicon 添加到 head 标签中
        if (!document.querySelector("link[rel*='icon']")) {
          head.appendChild(favicon);
        }
        localStorage.setItem("config", JSON.stringify(datas));
      });
    };
    let picture = (year, color, page, lottery) => {
      //图片请求
      if (page == 1) {
        loadingTips();
      }
      pictureCate({
        year: year,
        color: color,
        page: page,
        lotteryType: lottery
      }).then(res => {
        if (page == 1) {
          loadingTips("close");
        }
        if (res == undefined) return false;
        let datas = res.data.data.data;
        refreshing.value = false;
        if (datas.length == 0) {
          finished.value = false;
        } else {
          loading.value = false;
          data.pictureData.push(...datas);
          new Waterfall({
            el: "j_wrapper",
            //父div
            colmun: 2,
            //几列
            gap: 10 //间隙
          });
        }
      });
    };
    // let year = async()=>{//获取年份
    //     let res = await years();
    //     let c = res.data.data;

    //     localStorage.setItem('yearColor',JSON.stringify(c))
    //     data.yearList.push(...c)
    // }
    let yearsColos = async acitveIndexLottery => {
      //获取年份

      data.yearList.length = 0;
      // if ( sessionStorage.getItem('lotteryYears') == null) {
      let ress = await lottery_years_color();
      let lotteryYears = ress.data.data;
      sessionStorage.setItem("lotteryYears", JSON.stringify(lotteryYears));
      lotteryYears.forEach(item => {
        if (item.lotteryType == acitveIndexLottery) {
          data.yearList.push(...item.list);
        }
      });
      // } else {
      //     if(sessionStorage.getItem('lotteryYears')) {
      //         let lotteryYears = JSON.parse(sessionStorage.getItem('lotteryYears'));
      //         lotteryYears.forEach(item=>{
      //             if(item.lotteryType == acitveIndexLottery) {
      //                 data.yearList.push(...item.list);
      //             }
      //         })
      //     }

      // }
    };

    let yearAlls = () => {
      yearAll().then(res => {
        if (res == undefined) return false;
        let data = res.data.data;
        let reversed = data.reverse();
        localStorage.setItem("year", JSON.stringify(reversed));
      });
    };
    let swiperImgs = () => {
      //轮播图
      swiperImg().then(res => {
        if (res == undefined) return false;
        let datas = res.data.data.ad_list;
        data.swiperImgsrc.push(...datas);
        let datac = {
          value: datas,
          expires: Date.now() + 1000 * 60 * 60 // 1 hour from now
        };

        localStorage.setItem("swiperImg", JSON.stringify(datac));
      });
    };
    function stripHtmlAndEntities(html) {
      // 去除HTML标签
      const regex = /(<([^>]+)>)/gi;
      const plainText = html.replace(regex, "");

      // 去除HTML实体
      const entitiesRegex = /&([a-z]+|#\d+);/gi;
      const textWithoutEntities = plainText.replace(entitiesRegex, "");
      return textWithoutEntities;
    }
    let getMessages = (type, page) => {
      //首页公告
      getMessage({
        type: type,
        page: page
      }).then(res => {
        if (res == undefined) return false;
        let datasc = res.data.data.list;
        if (datasc.length == 0) {
          datas.shows = false;
          data.noticeCont = " ";
          localStorage.setItem("notice", data.noticeCont);
        } else {
          datasc.forEach((item, index) => {
            if (index < 2) {
              item.created_at = replaceStr1(item.created_at);
              data.noticeCont += " " + stripHtmlAndEntities(item.content);
              data.noticeData.push(item);
            }
          });
          data.prompt_title = data.noticeData[0].title;
          datas.shows = localStorage.getItem("announcement") == null ? true : false; //判断是否显示公告
          localStorage.setItem("notice", data.noticeCont);
        }
      });
    };
    const replaceStr1 = str => {
      const strAry = str.split("-");
      return strAry.join("/");
    };

    // const handleScroll = () => {//页面滚动的时候用于置顶判断

    //     const scrollTop = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;

    //     if(scrollTop - scroolData.yearTop>=0){

    //         scroolData.scrollYear = true
    //     }else{
    //         scroolData.scrollYear = false
    //     }
    // }
    //功能区域

    const $store = useStore(); //获取vuex

    let handleRefreshs = () => {
      data.transitions = true;
      localStorage.removeItem("lotteryNumber");
      datas.acitveIndexLottery = localStorage.getItem("lotteryType");
      data.refreshKey += 1;
      let c = setInterval(() => {
        clearTimeout(c);
        data.transitions = false;
      }, 1000);
    };
    let onSehar = () => {
      datas.show = true;
    };
    let lotteryFunSelect = (index, id) => {
      //彩票选择
      datas.acitveIndexLottery = id;
      data.pictureData.length = 0; //初始化
      data.page = 1; //初始化
      $store.commit("upLotteryCont", id);
      $store.commit("exidRelease", true);
      $store.commit("handleImgs", true);
      localStorage.setItem("discovery", true);
      switch (datas.acitveIndexLottery) {
        case "5":
          datas.lotteryName = "天澳彩";
          datas.types = "am48";
          getMaterials(datas.acitveIndexLottery);
          axiosTuku("am48");
          break;
        case "6":
          datas.lotteryName = "快乐八";
          getMaterials(datas.acitveIndexLottery);
          datas.types = "am48";
          axiosTuku("am48");
          break;
        case "7":
          datas.lotteryName = "老澳";
          getMaterials(datas.acitveIndexLottery);
          datas.types = "oldam";
          axiosTuku("oldam");
          break;
        case "2":
          datas.lotteryName = "新澳彩";
          datas.types = "am";
          getMaterials(datas.acitveIndexLottery);
          axiosTuku("am");
          break;
        case "1":
          datas.lotteryName = "港彩";
          datas.types = "xg";
          getMaterials(datas.acitveIndexLottery);
          axiosTuku("xg");
          break;
        case "3":
          datas.lotteryName = "台彩";
          datas.types = "tw";
          getMaterials(datas.acitveIndexLottery);
          axiosTuku("tw");
          break;
        case "4":
          getMaterials(datas.acitveIndexLottery);
          datas.lotteryName = "新彩";
          datas.types = "xjp";
          axiosTuku("xjp");
          break;
      }
      let yearList = JSON.parse(sessionStorage.getItem("yearList"));
      yearList.forEach((item, index) => {
        if (item.lotteryType == id) {
          localStorage.setItem("yearone", item.years[0]);
          data.year = item.years[0];
          localStorage.setItem("year", JSON.stringify(item.years));
        }
      });
    };
    let tipsData = reactive({
      //弹窗提示
      downloadapp: true
    });
    let colse = () => {
      //关闭app下载
      // localStorage.setItem('downloadapp',false);
      tipsData.downloadapp = "false";
    };
    let promptColse = () => {
      //关闭公告提示
      datas.shows = false;
    };
    let prompt = () => {
      //
      localStorage.setItem("announcement", 0);
      datas.shows = false;
    };
    //跳转页面
    let principalJump = item => {
      if (datas.acitveIndexLottery == 5) {
        if (item == "/lottery/history" || item == "/tool" || item == "/lottery") {
          router.push({
            path: item,
            query: {
              lottery: datas.acitveIndexLottery
            }
          });
        } else {
          Dialog("暂无数据");
        }
      } else {
        proxy.$sayHello();
        router.push({
          path: item
        });
      }
    };
    let pictureJump = item => {
      if (item.is_ad) {
        window.location.href = item.ad_url;
      } else {
        localStorage.setItem("comment", true);
        router.push({
          path: `/gallery`,
          query: {
            color: item.color,
            year: item.year,
            id: item.pictureTypeId,
            title: item.pictureName,
            image: item.pictureUrl
          }
        });
      }
    };
    const showTipsbs = ref(true);
    onMounted(async () => {
      if (localStorage.getItem("showDown") || route.query.showDown) {
        localStorage.setItem("showDown", 1);
        showTipsbs.value = false;
      } else {
        if (localStorage.getItem("label") || route.query.label) {
          showTipsbs.value = false;
        } else {
          showTipsbs.value = true;
        }
      }
    });
    onBeforeUnmount(() => {
      // window.removeEventListener('scroll', handleScroll)
    });
    return (_ctx, _cache) => {
      const _component_van_swipe_item = _resolveComponent("van-swipe-item");
      const _component_van_swipe = _resolveComponent("van-swipe");
      const _component_botton = _resolveComponent("botton");
      const _component_van_overlay = _resolveComponent("van-overlay");
      const _component_swipers = _resolveComponent("swipers");
      const _component_empty = _resolveComponent("empty");
      const _component_van_icon = _resolveComponent("van-icon");
      const _component_van_list = _resolveComponent("van-list");
      const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
      const _component_share = _resolveComponent("share");
      const _component_major = _resolveComponent("major");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(kt_header, {
        onSehar: _unref(onSehar),
        headLogo: _unref(websiteName).wide_logo,
        config: _unref(websiteName),
        onColse: _unref(colse)
      }, null, 8, ["onSehar", "headLogo", "config", "onColse"]), _createVNode(_component_van_overlay, {
        show: _unref(shows),
        "z-index": "999",
        onClick: _cache[1] || (_cache[1] = $event => _isRef(shows) ? shows.value = false : shows = false),
        "lock-scroll": false
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "wrappersss",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
        }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, _toDisplayString(_unref(prompt_title)), 1), _createVNode(_component_van_swipe, {
          class: "my-swipe",
          autoplay: 0,
          "indicator-color": "#07c160",
          onChange: _unref(handleSwipe)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(noticeData), (item, index) => {
            return _openBlock(), _createBlock(_component_van_swipe_item, {
              key: index
            }, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: "content",
                innerHTML: item.content
              }, null, 8, _hoisted_3)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        }, 8, ["onChange"]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_botton, {
          name: "关闭",
          color: "#999",
          bgcolor: "transparent",
          onClick: _withModifiers(_unref(promptColse), ["stop"])
        }, null, 8, ["onClick"]), _hoisted_5, _createVNode(_component_botton, {
          bgcolor: "transparent",
          color: "#07c160",
          style: {
            "margin-left": "10px"
          },
          name: "不再提示",
          onClick: _withModifiers(_unref(prompt), ["stop"])
        }, null, 8, ["onClick"])])])])]),
        _: 1
      }, 8, ["show"]), _createVNode(_component_van_pull_refresh, {
        modelValue: refreshing.value,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => refreshing.value = $event),
        onRefresh: onRefresh
      }, {
        default: _withCtx(() => [_createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[3] || (_cache[3] = $event => loading.value = $event),
          finished: finished.value,
          "finished-text": "",
          onLoad: onLoad
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_swipers, {
            swiperImg: _unref(swiperImgsrc)
          }, null, 8, ["swiperImg"])]), _createElementVNode("div", _hoisted_8, [_createVNode(notiveVue, {
            notiveInfo: _unref(noticeCont)
          }, null, 8, ["notiveInfo"])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tkHomeTabs), (item, index) => {
            return _openBlock(), _createElementBlock("li", {
              class: _normalizeClass(_unref(acitveIndexLottery) == item.id ? 'active' : ''),
              key: index,
              onClick: $event => _unref(lotteryFunSelect)(index, item.id)
            }, [_createElementVNode("div", _hoisted_11, [_unref(acitveIndexLottery) == item.id ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: item.selectIcon,
              alt: ""
            }, null, 8, _hoisted_12)) : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: item.icon,
              alt: ""
            }, null, 8, _hoisted_13))]), _createElementVNode("div", _hoisted_14, _toDisplayString(item.name), 1)], 10, _hoisted_10);
          }), 128))])]), _createElementVNode("div", {
            class: "tk-home-tabs-active tk-home-tabs",
            style: _normalizeStyle([{
              "background": "none"
            }, {
              bottom: showTipsbs.value ? '60px' : '110px'
            }])
          }, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tkHomeTabss), (item, index) => {
            return _openBlock(), _createElementBlock("li", {
              class: _normalizeClass(_unref(acitveIndexLottery) == item.id ? 'active' : ''),
              key: index,
              onClick: $event => _unref(lotteryFunSelect)(index, item.id)
            }, [_createElementVNode("div", _hoisted_16, [_unref(acitveIndexLottery) == item.id ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: item.selectIcon,
              alt: ""
            }, null, 8, _hoisted_17)) : (_openBlock(), _createElementBlock("img", {
              key: 1,
              src: item.icon,
              alt: ""
            }, null, 8, _hoisted_18))]), _createElementVNode("div", _hoisted_19, _toDisplayString(item.name), 1)], 10, _hoisted_15);
          }), 128))])], 4), _createElementVNode("div", _hoisted_20, [(_openBlock(), _createBlock(lottery, {
            lottery: _unref(acitveIndexLottery),
            key: _unref(refreshKey)
          }, null, 8, ["lottery"]))]), _createElementVNode("div", _hoisted_21, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tkHome), (item, index) => {
            return _openBlock(), _createElementBlock("li", {
              key: index,
              class: "flex-between",
              onClick: $event => _unref(principalJump)(item.path),
              style: _normalizeStyle({
                background: item.color
              })
            }, [_createElementVNode("div", _hoisted_23, [_createElementVNode("img", {
              src: item.icon,
              alt: ""
            }, null, 8, _hoisted_24)]), _createElementVNode("div", _hoisted_25, [item.name == '图库' ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(_unref(lotteryName) + item.name), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(item.name), 1)), _createElementVNode("div", _hoisted_28, _toDisplayString(item.desc), 1)])], 12, _hoisted_22);
          }), 128))])]), _unref(acitveIndexLottery) == 5 ? (_openBlock(), _createBlock(_component_empty, {
            key: 0,
            style: {
              "margin-top": "30px"
            }
          })) : (_openBlock(), _createElementBlock("div", _hoisted_29, [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("span", null, _toDisplayString(_unref(lotteryName)) + "正版挂牌", 1), _createElementVNode("p", {
            class: "more",
            onClick: _cache[2] || (_cache[2] = $event => _unref(guapaiInfo)(_unref(types)))
          }, [_hoisted_32, _createVNode(_component_van_icon, {
            name: "arrow"
          })])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("img", {
            src: _unref(gpData).img,
            alt: ""
          }, null, 8, _hoisted_34), _createElementVNode("table", null, [_createElementVNode("tr", null, [_createElementVNode("td", _hoisted_35, _toDisplayString(_unref(gpData).qi) + " 期", 1)]), _createElementVNode("tr", null, [_hoisted_36, _createElementVNode("td", _hoisted_37, _toDisplayString(_unref(gpData).hdl), 1)]), _createElementVNode("tr", null, [_hoisted_38, _createElementVNode("td", _hoisted_39, _toDisplayString(_unref(gpData).huoshao), 1)]), _createElementVNode("tr", null, [_hoisted_40, _createElementVNode("td", _hoisted_41, _toDisplayString(_unref(gpData).ci), 1)]), _createElementVNode("tr", null, [_hoisted_42, _createElementVNode("td", _hoisted_43, _toDisplayString(_unref(gpData).men), 1)]), _createElementVNode("tr", null, [_hoisted_44, _createElementVNode("td", _hoisted_45, _toDisplayString(_unref(gpData)["6xiao"]), 1)])])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(materData), (item, index) => {
            return _openBlock(), _createElementBlock("div", {
              class: "block",
              key: index
            }, [_createElementVNode("div", _hoisted_46, [_createElementVNode("span", null, _toDisplayString(item.corpusTypeName), 1), _createElementVNode("p", {
              class: "more",
              onClick: $event => _unref(moreZiliao)(item)
            }, [_hoisted_48, _createVNode(_component_van_icon, {
              name: "arrow"
            })], 8, _hoisted_47)]), item.list ? (_openBlock(), _createElementBlock("div", _hoisted_49, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.list, (items, i) => {
              return _openBlock(), _createElementBlock("div", {
                key: i,
                onClick: $event => _unref(handledesc)(items.id, item.id)
              }, [_createElementVNode("p", null, _toDisplayString(items.title), 1)], 8, _hoisted_50);
            }), 128))])) : _createCommentVNode("", true)]);
          }), 128))]))])]),
          _: 1
        }, 8, ["loading", "finished"])]),
        _: 1
      }, 8, ["modelValue"]), _unref(tipsData).downloadapp != 'false' && showTipsbs.value ? (_openBlock(), _createElementBlock("div", _hoisted_51, [_createElementVNode("div", _hoisted_52, [_createElementVNode("a", {
        href: _unref(websiteName).download_url
      }, "下载APP", 8, _hoisted_53)]), _createElementVNode("div", _hoisted_54, [_createElementVNode("a", {
        href: _unref(websiteName).download_url
      }, "看图更爽", 8, _hoisted_55)]), _createElementVNode("div", {
        class: "item c",
        onClick: _cache[5] || (_cache[5] = (...args) => _unref(colse) && _unref(colse)(...args))
      }, [_hoisted_56, _createVNode(_component_van_icon, {
        name: "cross",
        color: "#fff"
      })])])) : _createCommentVNode("", true), _createVNode(wecharList, {
        show: _unref(gameShow),
        "onUpdate:show": _cache[6] || (_cache[6] = $event => _isRef(gameShow) ? gameShow.value = $event : gameShow = $event),
        onSelecRoom: _unref(selecRoom),
        list: _unref(list)
      }, null, 8, ["show", "onSelecRoom", "list"]), _createVNode(_component_share, {
        shows: _unref(show),
        "onUpdate:shows": _cache[7] || (_cache[7] = $event => _isRef(show) ? show.value = $event : show = $event)
      }, null, 8, ["shows"]), _createVNode(_component_major, {
        onMajorTab: _unref(majorTab)
      }, null, 8, ["onMajorTab"]), _createElementVNode("div", _hoisted_57, [_createElementVNode("div", {
        class: "tk-major-image",
        onClick: _cache[8] || (_cache[8] = (...args) => _unref(handleRefreshs) && _unref(handleRefreshs)(...args))
      }, [_createElementVNode("img", {
        class: _normalizeClass(_unref(transitions) ? 'active' : ''),
        src: _imports_0,
        alt: ""
      }, null, 2)])]), _createVNode(_component_van_overlay, {
        show: _unref(showss),
        "z-index": "1000"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "wrapper",
          onClick: _cache[12] || (_cache[12] = _withModifiers($event => _isRef(showss) ? showss.value = false : showss = false, ["stop"]))
        }, [_createElementVNode("div", _hoisted_58, [_createElementVNode("div", {
          class: "colse",
          onClick: _cache[9] || (_cache[9] = (...args) => _unref(colse) && _unref(colse)(...args))
        }, _hoisted_60), _createElementVNode("div", _hoisted_61, [_hoisted_62, _createElementVNode("div", _hoisted_63, [_createElementVNode("ul", null, [_createElementVNode("li", {
          onClick: _cache[10] || (_cache[10] = $event => _unref(selecRooms)(1))
        }, _hoisted_66), _createElementVNode("li", {
          onClick: _cache[11] || (_cache[11] = $event => _unref(selecRooms)(2))
        }, _hoisted_69)])])])])])]),
        _: 1
      }, 8, ["show"]), _hoisted_70], 64);
    };
  }
};